import { useInstancesByClassName } from 'hive-react-utils';
export function useSurveyResults() {
    // TODO: change to a query with startTime and endTime
    return useInstancesByClassName('survey', 'surveyResults');
}
